module.exports = __webpack_public_path__ + "img/pop_perce.17e06856.png";